export default "__VITE_ASSET__Bytmk1t___"